module.exports = __webpack_public_path__ + "jab/media/catalog.2feccadd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/catalog.svg
// module id = 1471
// module chunks = 0